import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["item", "category", "tab"];

  connect() {
    this.currentCategory = "All";
    this.query = "";
  }

  search(event) {
    this.query = event.target.value.toLowerCase();
    this.applyFilters();
  }

  filterCategory(event) {
    this.currentCategory = event.currentTarget.dataset.category;
    
    // Update active tab styling
    this.tabTargets.forEach(tab => {
      if (tab.dataset.category === this.currentCategory) {
        tab.classList.add("kanban-view-tab-active");
        tab.classList.remove("kanban-view-tab");
      } else {
        tab.classList.add("kanban-view-tab");
        tab.classList.remove("kanban-view-tab-active");
      }
    });

    this.applyFilters();
  }

  applyFilters() {
    this.itemTargets.forEach(item => {
      const name = item.dataset.name.toLowerCase();
      const description = item.dataset.description.toLowerCase();
      const category = item.dataset.category;

      const matchesSearch = !this.query || name.includes(this.query) || description.includes(this.query);
      const matchesCategory = this.currentCategory === "All" || category === this.currentCategory;

      if (matchesSearch && matchesCategory) {
        item.style.display = "";
      } else {
        item.style.display = "none";
      }
    });

    // Hide/show category sections
    this.categoryTargets.forEach(section => {
      const sectionCategory = section.dataset.category;
      
      // If filtering by specific category, hide others
      if (this.currentCategory !== "All" && sectionCategory !== this.currentCategory) {
        section.style.display = "none";
        return;
      }

      // Check if any visible items belong to this category section
      const hasVisibleItems = Array.from(this.itemTargets).some(item => 
        item.dataset.category === sectionCategory && item.style.display !== "none"
      );

      section.style.display = hasVisibleItems ? "" : "none";
    });
  }
}
